
export class PostControlInfoDto {
    infoId;
    documentId;
    isFinalInfo;
    issueDate;
    remarksIssueDate;
    isValidated;
    legalBasis;
    controlPurpose;
    controlSubject;
    controlSummary;
    finalInstructions;
    creatingPerson;
    creationDate;
    modificationPerson;
    modificationDate;
    postControlDocument;
    abbreviations;
    findings=[];
    checklistVersion;
    attachments;
}


















